/** Returns true only while the reasoning part itself is still streaming. */
export function isReasoningPartStreaming(part: { type: string; state?: string }): boolean {
  return (
    part.type === "reasoning-delta" ||
    part.state === "streaming" ||
    part.state === "input-streaming"
  );
}
